enum ModuleComponent {
    Logic = 'Logic',
}

export default ModuleComponent;